export function validateQuantityBounds(
  n: number,
  min: number,
  max?: number
): number {
  const maxValue = min ? Math.max(n, min) : n

  return max ? Math.min(maxValue, max) : maxValue
}
